import { render, staticRenderFns } from "./EmployeeShiftBoards.vue?vue&type=template&id=428579f8&scoped=true"
import script from "./EmployeeShiftBoards.vue?vue&type=script&lang=js"
export * from "./EmployeeShiftBoards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428579f8",
  null
  
)

export default component.exports